module.exports = __webpack_public_path__ + "static/media/leave-slider-tip.4ded8703.gif";